<template>
  <div class="password-page">
    <!-- ========== 顶部标题栏 ========== -->
    <div class="page-header">
      <div class="header-back" @click="router.back()">
        <nut-icon name="left" size="18" color="#3a3226"></nut-icon>
      </div>
      <span class="header-title">修改密码</span>
      <div class="header-placeholder"></div>
    </div>

    <!-- ========== 表单区域 ========== -->
    <div class="form-section">
      <!-- 原密码 -->
      <div class="input-group">
        <div class="input-icon-box">
			<svg t="1782717515325" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7773" width="18" height="18">
				<path fill="#8B7355" d="M259.64544 457.44128l504.7296 0c20.35712 0 38.44096 8.2944 51.99872 21.83168 13.57824 13.57824 21.83168 31.66208 21.83168 52.0192l0 342.75328c0 19.5584-8.25344 38.42048-21.83168 51.97824l0 0c-13.55776 12.8-31.6416 21.07392-51.99872 21.07392L259.64544 947.0976c-20.33664 0-39.19872-8.27392-51.99872-21.07392-13.57824-13.55776-21.83168-31.66208-21.83168-51.97824L185.81504 531.29216c0-20.35712 8.27392-38.44096 21.83168-52.0192l0 0 0 0C221.20448 465.75616 239.3088 457.44128 259.64544 457.44128L259.64544 457.44128zM764.35456 497.39776 259.64544 497.39776c-9.80992 0-18.08384 3.72736-24.12544 9.76896l0 0c-6.02112 6.0416-9.78944 15.09376-9.78944 24.14592l0 342.75328c0 9.0112 3.76832 17.32608 9.78944 23.36768 6.0416 6.02112 15.07328 9.78944 24.12544 9.78944l504.7296 0c9.05216 0 17.36704-3.76832 24.12544-9.78944l0 0c6.06208-6.0416 9.80992-14.336 9.80992-23.36768L798.3104 531.29216c0-9.03168-3.76832-18.10432-9.80992-24.14592C781.7216 501.12512 773.4272 497.39776 764.35456 497.39776L764.35456 497.39776z" p-id="7774"></path>
				<path fill="#8B7355" d="M753.07008 351.21152c0 10.5472-9.05216 19.59936-20.35712 19.59936-11.28448 0-19.53792-9.05216-19.53792-19.59936 0-55.74656-22.60992-106.20928-58.75712-142.37696-36.94592-36.1472-86.67136-58.75712-142.39744-58.75712-55.76704 0-106.22976 22.60992-142.39744 58.75712-36.16768 36.16768-58.75712 86.6304-58.75712 142.37696l0 118.272c0 10.5472-9.05216 19.59936-19.59936 19.59936-11.28448 0-20.33664-9.03168-20.33664-19.59936l0-118.272c0-66.29376 27.11552-126.5664 70.79936-170.25024 43.7248-43.68384 103.97696-70.81984 170.2912-70.81984 66.29376 0 126.5664 27.11552 170.27072 70.81984C725.95456 224.6656 753.07008 284.93824 753.07008 351.21152L753.07008 351.21152z" p-id="7775"></path>
			</svg>
          <!-- <nut-icon name="lock" size="18" color="#8B7355"></nut-icon> -->
        </div>
        <div class="input-wrapper">
          <label class="input-label">原密码</label>
          <input
            class="form-input"
            :type="showOld ? 'text' : 'password'"
            v-model="form.oldPassword"
            placeholder="请输入原密码"
            autocomplete="current-password"
          />
        </div>
        <div class="input-eye" @click="showOld = !showOld">
          <nut-icon :name="showOld ? 'eye' : 'photograph'" size="16" color="#ccc"></nut-icon>
        </div>
      </div>

      <!-- 新密码 -->
      <div class="input-group">
        <div class="input-icon-box">
			<svg t="1782717515325" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7773" width="18" height="18">
				<path fill="#8B7355" d="M259.64544 457.44128l504.7296 0c20.35712 0 38.44096 8.2944 51.99872 21.83168 13.57824 13.57824 21.83168 31.66208 21.83168 52.0192l0 342.75328c0 19.5584-8.25344 38.42048-21.83168 51.97824l0 0c-13.55776 12.8-31.6416 21.07392-51.99872 21.07392L259.64544 947.0976c-20.33664 0-39.19872-8.27392-51.99872-21.07392-13.57824-13.55776-21.83168-31.66208-21.83168-51.97824L185.81504 531.29216c0-20.35712 8.27392-38.44096 21.83168-52.0192l0 0 0 0C221.20448 465.75616 239.3088 457.44128 259.64544 457.44128L259.64544 457.44128zM764.35456 497.39776 259.64544 497.39776c-9.80992 0-18.08384 3.72736-24.12544 9.76896l0 0c-6.02112 6.0416-9.78944 15.09376-9.78944 24.14592l0 342.75328c0 9.0112 3.76832 17.32608 9.78944 23.36768 6.0416 6.02112 15.07328 9.78944 24.12544 9.78944l504.7296 0c9.05216 0 17.36704-3.76832 24.12544-9.78944l0 0c6.06208-6.0416 9.80992-14.336 9.80992-23.36768L798.3104 531.29216c0-9.03168-3.76832-18.10432-9.80992-24.14592C781.7216 501.12512 773.4272 497.39776 764.35456 497.39776L764.35456 497.39776z" p-id="7774"></path>
				<path fill="#8B7355" d="M753.07008 351.21152c0 10.5472-9.05216 19.59936-20.35712 19.59936-11.28448 0-19.53792-9.05216-19.53792-19.59936 0-55.74656-22.60992-106.20928-58.75712-142.37696-36.94592-36.1472-86.67136-58.75712-142.39744-58.75712-55.76704 0-106.22976 22.60992-142.39744 58.75712-36.16768 36.16768-58.75712 86.6304-58.75712 142.37696l0 118.272c0 10.5472-9.05216 19.59936-19.59936 19.59936-11.28448 0-20.33664-9.03168-20.33664-19.59936l0-118.272c0-66.29376 27.11552-126.5664 70.79936-170.25024 43.7248-43.68384 103.97696-70.81984 170.2912-70.81984 66.29376 0 126.5664 27.11552 170.27072 70.81984C725.95456 224.6656 753.07008 284.93824 753.07008 351.21152L753.07008 351.21152z" p-id="7775"></path>
			</svg>
          <!-- <nut-icon name="key" size="18" color="#8B7355"></nut-icon> -->
        </div>
        <div class="input-wrapper">
          <label class="input-label">新密码</label>
          <input
            class="form-input"
            :type="showNew ? 'text' : 'password'"
            v-model="form.newPassword"
            placeholder="请输入新密码（6-20位）"
            autocomplete="new-password"
          />
        </div>
        <div class="input-eye" @click="showNew = !showNew">
          <nut-icon :name="showNew ? 'eye' : 'photograph'" size="16" color="#ccc"></nut-icon>
        </div>
      </div>

      <!-- 密码强度指示 -->
      <div class="strength-bar" v-if="form.newPassword">
        <div class="strength-levels">
          <span :class="['level-seg', { active: strengthLevel >= 1, weak: strengthLevel === 1 }]"></span>
          <span :class="['level-seg', { active: strengthLevel >= 2, medium: strengthLevel === 2 }]"></span>
          <span :class="['level-seg', { active: strengthLevel >= 3, strong: strengthLevel === 3 }]"></span>
        </div>
        <span class="strength-text">{{ strengthText }}</span>
      </div>

      <!-- 确认新密码 -->
      <div class="input-group">
        <div class="input-icon-box">
          <nut-icon name="checklist" size="18" color="#8B7355"></nut-icon>
        </div>
        <div class="input-wrapper">
          <label class="input-label">确认密码</label>
          <input
            class="form-input"
            :type="showConfirm ? 'text' : 'password'"
            v-model="form.confirmPassword"
            placeholder="请再次输入新密码"
            autocomplete="new-password"
          />
        </div>
        <div class="input-eye" @click="showConfirm = !showConfirm">
          <nut-icon :name="showConfirm ? 'eye' : 'photograph'" size="16" color="#ccc"></nut-icon>
        </div>
      </div>

      <!-- 密码不匹配提示 -->
      <div class="mismatch-hint" v-if="form.confirmPassword && form.newPassword !== form.confirmPassword">
        <nut-icon name="circle-warn" size="14" color="#e87373"></nut-icon>
        <span>两次输入的密码不一致</span>
      </div>

      <!-- 提示信息 -->
      <div class="tips-card">
        <nut-icon name="tips" size="14" color="#C5A47E"></nut-icon>
        <span>密码长度 6-20 位，建议包含字母、数字和特殊字符</span>
      </div>

      <!-- 提交按钮 -->
      <button
        class="submit-btn"
        :class="{ disabled: !canSubmit }"
        :disabled="!canSubmit || submitting"
        @click="handleSubmit"
      >
        <span v-if="!submitting">确认修改</span>
        <span v-else class="btn-loading">
          <i class="spinner"></i> 提交中…
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, getCurrentInstance} from 'vue';
import { useRouter } from 'vue-router';
import { Toast } from '@nutui/nutui';

const { proxy } = getCurrentInstance();
const router = useRouter();

// 表单
const form = reactive({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
});

// 密码可见性
const showOld = ref(false);
const showNew = ref(false);
const showConfirm = ref(false);
const submitting = ref(false);

// 密码强度
const strengthLevel = computed(() => {
  const pwd = form.newPassword;
  if (!pwd) return 0;
  let score = 0;
  if (pwd.length >= 6) score++;
  if (pwd.length >= 10) score++;
  if (/[a-zA-Z]/.test(pwd) && /[0-9]/.test(pwd)) score++;
  if (/[^a-zA-Z0-9]/.test(pwd)) score++;
  return Math.min(3, score);
});

const strengthText = computed(() => {
  const map = { 0: '', 1: '弱', 2: '中等', 3: '强' };
  return map[strengthLevel.value] || '';
});

// 是否可以提交
const canSubmit = computed(() => {
  return (
    form.oldPassword &&
    form.newPassword &&
    form.confirmPassword &&
    form.newPassword === form.confirmPassword &&
    form.newPassword.length >= 6 &&
    form.newPassword.length <= 20
  );
});

// 提交
const handleSubmit = () => {
  if (!form.oldPassword) {
    Toast.text('请输入原密码');
    return;
  }
  if (!form.newPassword || form.newPassword.length < 6) {
    Toast.text('新密码长度不能少于6位');
    return;
  }
  if (form.newPassword.length > 20) {
    Toast.text('新密码长度不能超过20位');
    return;
  }
  if (form.newPassword !== form.confirmPassword) {
    Toast.text('两次输入的密码不一致');
    return;
  }
  if (form.oldPassword === form.newPassword) {
    Toast.text('新密码不能与原密码相同');
    return;
  }

  submitting.value = true;

  // TODO: 调用修改密码接口
  
  proxy.$axios.updatePwd({newPassword:form.newPassword,oldPassword:form.oldPassword}).then(res=>{
	  submitting.value = false;
	  if(res.data.code == 200){
		  Toast.text('密码修改成功');
		  setTimeout(() => router.back(), 1000);
	  }
  })
};
</script>

<style scoped>
/* ========== 页面整体 ========== */
.password-page {
  min-height: 100vh;
  background: #f5f3f0;
}

/* ========== 顶部标题栏 ========== */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
  padding: 0 16px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #f0ede8;
}
.header-back {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: background 0.2s;
}
.header-back:active {
  background: #f5f3f0;
}
.header-title {
  font-size: 17px;
  font-weight: 600;
  color: #3a3226;
  letter-spacing: 1px;
}
.header-placeholder {
  width: 32px;
}

/* ========== 表单区域 ========== */
.form-section {
  padding: 20px 16px;
}

/* ========== 输入组 ========== */
.input-group {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 14px;
  padding: 0 16px;
  height: 62px;
  margin-bottom: 12px;
  border: 1.5px solid transparent;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}
.input-group:focus-within {
  border-color: #C5A47E;
  box-shadow: 0 0 0 3px rgba(197, 164, 126, 0.1);
}
.input-icon-box {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f5f0e8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}
.input-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.input-label {
  font-size: 11px;
  color: #bbb;
  margin-bottom: 2px;
  text-align: left;
}
.form-input {
  border: none;
  outline: none;
  font-size: 15px;
  color: #333;
  background: transparent;
  font-family: inherit;
  width: 100%;
}
.form-input::placeholder {
  color: #d0cdc8;
  font-size: 13px;
}
.input-eye {
  padding: 8px;
  cursor: pointer;
  flex-shrink: 0;
}

/* ========== 密码强度 ========== */
.strength-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 6px 8px;
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.strength-levels {
  display: flex;
  gap: 5px;
}
.level-seg {
  width: 48px;
  height: 4px;
  border-radius: 2px;
  background: #e8e5e0;
  transition: all 0.3s ease;
}
.level-seg.active.weak {
  background: #e87373;
}
.level-seg.active.medium {
  background: #faad14;
}
.level-seg.active.strong {
  background: #5a8a6a;
}
.strength-text {
  font-size: 12px;
  color: #999;
}

/* ========== 不匹配提示 ========== */
.mismatch-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 6px 4px;
  font-size: 12px;
  color: #e87373;
}

/* ========== 提示卡片 ========== */
.tips-card {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 24px;
  font-size: 13px;
  color: #999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

/* ========== 提交按钮 ========== */
.submit-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: linear-gradient(135deg, #8B7355, #a89070);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(139, 115, 85, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.submit-btn:active {
  transform: scale(0.97);
}
.submit-btn.disabled {
  background: #ddd;
  box-shadow: none;
  cursor: not-allowed;
  color: #999;
}

/* 按钮加载 */
.btn-loading {
  display: flex;
  align-items: center;
  gap: 8px;
}
.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
